var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("section", {
    staticClass: "wrapper"
  }, [_c("div", {
    class: [_vm.isDisabledMap && "map-disabled", _vm.isPointerDisabled && "pointer-disabled"],
    attrs: {
      id: "container-map"
    }
  }), _vm.noTargetFound ? _c("span", {
    staticClass: "notfound-label"
  }, [_vm._v(" We didn't find this place. We are working to make it available soon. ")]) : _vm._e()]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };